import React, { Component } from 'react';
import {
  Container,
} from 'reactstrap';
import AdminContainer from '../../components/Admin/AdminContainer';


class Admin extends Component {

  render() {
    return (<Container fluid={true}>
      <AdminContainer {...this.props}/>
    </Container>
    );
  }
}

export default Admin;
